import { useState } from 'react';
import { useGuestProfileService } from "../services/guestProfileService";

export function useGetGuestProfiles() {
  const [guestProfiles, setGuestProfiles] = useState({})
  const { getGuestProfiles } = useGuestProfileService();

  const getGuestProfilesAction = async (payload) => {
    const guestProfilesData =  await getGuestProfiles(payload);
    setGuestProfiles(guestProfilesData);
  }

  return {
    guestProfiles,
    getGuestProfilesAction
  };
}
